import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          {/* Left Content */}
          <div className="flex-1 lg:w-[45%]">
            <span className="inline-block px-4 py-1.5 border border-foreground-200 rounded-full text-xs font-medium text-foreground-600 mb-6">
              About Pandabuy Sheet
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-8">
              Your Trusted
              <br />
              <span className="text-primary-600">Product Directory</span>
            </h2>
            <div className="space-y-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              <p>
                Finding reliable <strong>pandabuy spreadsheet</strong> links can be overwhelming. Our directory 
                organizes thousands of verified product links across 14 carefully curated categories, 
                making it easier than ever to discover exactly what you need.
              </p>
              <p>
                Every link in our <strong>pandabuy spreadsheet</strong> is checked and updated regularly. 
                We focus on quality over quantity — each product is selected based on seller reputation, 
                community feedback, and consistent availability. Whether you are looking for sneakers, 
                hoodies, bags, or accessories, the <strong>best pandabuy spreadsheet</strong> is right here.
              </p>
              <p>
                Our updated <strong>pandabuy spreadsheet 2026</strong> includes fresh links daily. 
                Save time, avoid dead links, and shop with confidence using a directory built by 
                experienced community members who understand what makes a great find.
              </p>
            </div>
            <div className="mt-8">
              <Link
                to="/pandabuy-sheet-guide"
                className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 border-b-2 border-primary-300 hover:border-primary-500 pb-1 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Our Complete Guide <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {/* Right Stats + Images */}
          <div className="flex-1 lg:w-[55%] flex flex-col gap-8">
            {/* Stats */}
            <div className="flex items-end gap-12 md:gap-16">
              <div>
                <p className="text-4xl md:text-5xl font-bold text-foreground-950">20,000+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Products indexed across all categories</p>
              </div>
              <div>
                <p className="text-4xl md:text-5xl font-bold text-foreground-950">500+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Verified &amp; updated pandabuy links</p>
              </div>
            </div>
            <div>
              <p className="text-4xl md:text-5xl font-bold text-foreground-950">Daily</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">Spreadsheet updates with fresh finds</p>
            </div>

            {/* Images */}
            <div className="relative mt-4">
              <div className="grid grid-cols-2 gap-3">
                <img
                  src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20photography%20of%20curated%20fashion%20accessories%20including%20a%20woven%20belt%20leather%20wallet%20and%20sunglasses%20arranged%20elegantly%20on%20a%20warm%20cream%20linen%20surface%20with%20soft%20natural%20window%20light%20casting%20gentle%20shadows%2C%20minimalist%20editorial%20composition%20with%20abundant%20negative%20space%2C%20neutral%20earthy%20tones%20throughout%2C%20high%20detail%20textures%20visible%2C%20sophisticated%20lifestyle%20aesthetic&width=500&height=500&seq=about-img-v2-01&orientation=squarish"
                  alt="Curated pandabuy products flat lay"
                  className="w-full aspect-square object-cover object-top rounded-lg"
                />
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20carefully%20styled%20casual%20outfit%20including%20a%20light%20overshirt%20and%20trousers%20displayed%20on%20a%20minimalist%20warm%20beige%20backdrop%2C%20clean%20modern%20aesthetic%20with%20soft%20diffused%20studio%20lighting%20creating%20gentle%20even%20illumination%2C%20elegant%20lookbook%20composition%2C%20neutral%20sandy%20and%20cream%20tones%2C%20high%20end%20contemporary%20style%2C%20no%20visible%20branding%20or%20logos&width=500&height=700&seq=about-img-v2-02&orientation=portrait"
                  alt="Stylish outfit showcase"
                  className="w-full aspect-[3/4] object-cover object-top rounded-lg mt-8"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}